import React from 'react';
import withRouter from 'src/config/withRouter';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
// typeicon
import { SportsSoccerOutlined, GestureOutlined, SchoolOutlined, ComputerOutlined, FavoriteOutlined, TollOutlined, StorefrontOutlined,
BusinessOutlined, SentimentVerySatisfiedOutlined, ArrowForwardIosOutlined, EventAvailableOutlined, ExtensionOutlined, DesktopMacOutlined } from '@mui/icons-material';
// imags
import backImg from '../../assets/images/back.png';
import logoImg from '../../assets/images/logo.png';

const styles = theme => ({
    card:{
        width:'28%',
        height:'auto',
        borderRadius:'10px',
        backgroundColor:'#fff',
        display:'flex',
        flexDirection:'column',
        boxShadow: '0 2px 7px gainsboro',
        marginBottom:'20px',
        [theme.breakpoints.between('sm','lg')]:{
            width:'45%'
        },
        [theme.breakpoints.down('sm')]:{
            width:'90%'
        },
    },

    photoDiv:{
        width:'100%',
        position:'relative',
        height:'160px',
        borderTopRightRadius:'10px',
        borderTopLeftRadius:'10px',
        backgroundImage: `url(${backImg})`,
        backgroundSize:'cover',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& img':{
            width:'100%',
            height:'100%',
            borderRadius:'50%'
        }
    },

    companyName:{
        fontSize:'19px',
        color:'#000',
        fontWeight:'bold',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width:'90%',
        padding:'5px 0px 0px 10px',
        fontFamily:"'Cairo', sans-serif"
    },

    innDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        backgroundColor:'#fff',
        padding:'5px 0px 5px 0px',
    },

    typeText:{
        color:'#B329CD',
        fontSize:'19px',
        fontWeight:'bold',
        fontFamily: "'Cairo', sans-serif",
        paddingLeft:'10px',
        textTransform:'capitalize'
    },

    iconDiv:{
        display:'flex',
        flexDirection:'row',
        padding:'5px 10px',
        backgroundColor:'#F7F7F7',
        alignItems:'center'
    },

    detailBtn:{
        textDecoration: 'none',
        alignSelf: 'flex-end',
        border: 'none',
        outline: 'none',
        borderRadius: '50px',
        backgroundColor: '#0F467A',
        color: '#fff',
        marginRight:'10px',
        marginBottom:'10px',
        padding: '12px 20px',
        cursor: 'pointer',
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        textAlign: 'center',
        '-webkit-box-shadow': '0 10px 6px -6px #bdc3c7',
        '-moz-box-shadow': '0 10px 6px -6px #bdc3c7',
        boxShadow: '0 10px 6px -6px #bdc3c7',
        fontSize:'16px',
    },

    imgDiv:{
        width:'160px',
        height:'160px',
        '-webkit-box-shadow': '0 10px 6px -6px #bdc3c7',
        '-moz-box-shadow': '0 10px 6px -6px #bdc3c7',
        boxShadow: '0 10px 6px -6px #bdc3c7',
        borderRadius:'50%',
        backgroundColor:'#fff'
    }
})

function Type(props) {
    const {type} = props;
    return (type === 'sports' || type === 'sports center') ?
        <SportsSoccerOutlined style={{color:'#4C3E91'}}/>
    :
    (type === 'art' || type === 'art center') ?
        <GestureOutlined style={{color:'#8AB32A'}}/>
    :
    (type === 'school' || type === 'education' || type === 'education provider') ? 
        <SchoolOutlined style={{color:'#32ff7e'}}/>
    :
    (type === 'nursery') ? 
        <ExtensionOutlined style={{color:'#2ed573'}}/>
    :
    (type === 'instructor/tutor') ?
        <DesktopMacOutlined style={{color:'#0AB8E5'}}/>
    :
    (type === 'training center') ?
        <BusinessOutlined style={{color:'#ff5e57'}}/>
    :
    (type === 'online' || type === 'online services') ?
        <ComputerOutlined style={{color:'#0be881'}}/>
    :
    (type === 'party organizer') ?
        <EventAvailableOutlined style={{color:'#0F467A'}}/>
    :
    (type === 'entertainment') ?
        <SentimentVerySatisfiedOutlined style={{color:'#00d2d3'}}/>
    :
    (type === 'health care provider') ?
        <FavoriteOutlined style={{color:'#ff7f50'}}/>
    :
    (type === 'stores') ?
    <StorefrontOutlined style={{color:'#1dd1a1'}}/>
    :
    <TollOutlined style={{color:'#c56cf0'}}/>       
}

class CompanyCard extends React.Component {

    render() {
        const { classes, i18n,cover,clickEvent,type,name } = this.props

        let borderColor= (type === 'sports' || type === 'sports center') ? '#4C3E91'
        :
        (type === 'art' || type === 'art center') ? '#8AB32A'
        :
        (type === 'school' || type === 'education' || type === 'education provider') ? '#32ff7e'
        :
        type === 'nursery' ? '#2ed573'
        :
        type === 'instructor/tutor' ? '#0AB8E5'
        :
        type === 'training center' ? '#ff5e57'
        :
        (type === 'online' || type === 'online services') ? '#0be881'
        :
        type === 'party organizer' ? '#0F467A'
        :
        type === 'entertainment' ? '#00d2d3'
        :
        type === 'health care provider' ? '#ff7f50'
        :
        type === 'stores' ? '#1dd1a1'
        : '#c56cf0';

        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en; 
    return(
        <div dir={isRTL === 'ar' ? 'rtl' : 'ltr'} className={classes.card}>
            {/* photoDiv */}
            <div className={classes.photoDiv}>
                <div className={classes.imgDiv}>
                    <img alt='company-img' src={cover ?? logoImg} onError={(e)=>{e.target.onerror = null; e.target.src=logoImg}} style={{objectFit:'contain'}}/>
                </div>
            </div>
            
            <span className={classes.companyName}>{name}</span>

            <div className={classes.innDiv}>
                <span className={classes.typeText}>{type ?? '---'}</span>
                <div className={classes.iconDiv} dir={isRTL === 'ar' ? 'rtl' : 'ltr'} style={{borderRight:`7px solid ${borderColor}`,borderTopLeftRadius:'20px',borderBottomLeftRadius:'20px'}}>
                    <Type type={type}/>
                </div>
            </div>

            <div className={classes.detailBtn} style={{fontFamily}} onClick={clickEvent}>
                <span>Detail</span>
                <ArrowForwardIosOutlined />
            </div>
        </div>
    )
    }
}

export default withRouter(withStyles(styles)(withTranslation('common')(CompanyCard)));